import React from 'react';
import { useAtomValue } from 'jotai';

import { customTravelFormStateAtom } from '@/atoms/customTravelFormState';
import SelectCustomTypeForm from '../ServiceForm/forms/SelectCustomTypeForm';

interface SelectCustomTypeProps {}

const SelectCustomType: React.FC<SelectCustomTypeProps> = () => {
  const { estimateType } = useAtomValue(customTravelFormStateAtom);

  return <SelectCustomTypeForm externalValues={estimateType ? { estimateType } : undefined} />;
};

export default SelectCustomType;
